import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import '../../App.css';
import {dataRegister} from "../../services/dataRegister";
import {cartRegister} from "../../services/cartRegister";
import {langRegister} from "../../services/langRegister";
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as Icon from "react-feather";
import {marketRegister} from "../../services/marketRegister";
import Basket from "../../components/basket/component";
import ReactGA from 'react-ga';
import ErrorHandler from "../../components/error-handler/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import RegionSearch from "../../components/region-search/component";

class SignupFilter extends Component {

    constructor(props) {
        super(props);
        /*
        this.state = {
            tab: "basic",
            industry: null,
            related_industries: [],
            regions: [],
            regions_selected: [],
            country_region: {},
            vat: 0,
            currency: null,
            country: false,
            market: null,
            lockin_plans: null,
            dropdown: false,
            search: "",
            budget: null,
            duration: 0,
            durations: [],
            isLoading: true,
            targets: [],
            age_range: [],
            lang: null,
            regionLoader: false,
            service_fee_fixed: null,
            service_fee_percentage: null,
            error: false
        };
        */
        this.state = {
            tab: "basic",
            advanced_tab: "",
            industry: null,
            slogans: [],
            related_industries: [],
            regions: [],
            regions_selected: [],
            regions_grid: {},
            ad_languages: [],
            interests: [],
            interests_selected: [],
            interests_grid: {},
            industries: [],
            industries_selected: [],
            behaviors: [],
            behaviors_selected: [],
            behavior_grid: {},
            vat: 0,
            currency: null,
            country: false,
            market: null,
            language: null,
            country_region: {},
            default_ad_language: {},
            lockin_plans: null,
            dropdown: false,
            dropdown_industry: false,
            search: "",
            searchInterest: "",
            searchIndustry: "",
            searchBehavior: "",
            budget: null,
            duration: null,
            durations: [],
            isLoading: true,
            targets: [],
            age_range: [],
            lang: null,
            regionLoader: false,
            service_fee_fixed: null,
            service_fee_percentage: null,
            error: false,
            reseller: false,
            inhouse: false,
            count: 0,
            page: 1,
            related_open: false,
            keyword_languages: []
        };
        this._updateBudget = this._updateBudget.bind(this);
        this._selectDuration = this._selectDuration.bind(this);
        this._updateSelectedRegions = this._updateSelectedRegions.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();
        this._updateTab();
        this._updateUser();

        if(window.innerWidth > 1050){
            this.setState({count: 30});
        }else{
            this.setState({count: 20});
        }

        //GOOGLE ANALYTICS
        if(window.location.href.indexOf("devadbop.com") === -1){
            ReactGA.pageview('/signup-filter');
        }
    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse
                });
            }
        } catch (e) {}
    }

    _updateData() {
        let stored_data = cartRegister.get();
        if (stored_data.admin_image) {
            if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
            }
        }
        if (stored_data.industry && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.budget && stored_data.plan) {
            this.setState({
                market: salesChannelRegister.get('market'),
                currency: salesChannelRegister.get('currency'),
                vat: salesChannelRegister.get('vat'),
                country_region: JSON.parse(salesChannelRegister.get('country_region')),
                default_language: salesChannelRegister.get('default_language'),
                ad_languages: JSON.parse(salesChannelRegister.get('ad_languages')),
                available_keyword_languages: JSON.parse(salesChannelRegister.get('keyword_languages')),
                keyword_languages: stored_data.keyword_languages ? stored_data.keyword_languages : [],
                service_fee_percentage: stored_data.servicefee_percentage,
                service_fee_fixed: stored_data.servicefee_fixed,
                industry: stored_data.industry,
                channels: stored_data.channels,
                regions_selected: stored_data.regions ? stored_data.regions : [],
                industries_selected: stored_data.extra_industries ? stored_data.extra_industries : [],
                budget: stored_data.budget,
                related_industries: stored_data.related_industries ? stored_data.related_industries : [],
                interests_selected: stored_data.interests ? stored_data.interests : [],
                behaviors_selected: stored_data.behaviors ? stored_data.behaviors : [],
                duration: stored_data.duration,
                durations: JSON.parse(salesChannelRegister.get("durations")),
                optimization_goal: stored_data.crossroad === "instant"?2:1,
                lockin_plans: stored_data.lockin_plans ? stored_data.lockin_plans : null,
                language: stored_data.language ? stored_data.language : salesChannelRegister.get('default_ad_language'),
                plan: stored_data.plan,
                targets: stored_data.targets ? stored_data.targets : [{
                    title: this._renderText("item_38"),
                    selected: true,
                    value: "m"
                }, {
                    title: this._renderText("item_39"),
                    selected: true,
                    value: "f"
                }],
                age_range: stored_data.age_range ? stored_data.age_range : [18, 65]
            }, () => {

                this._updateSlogans();
                this._updateIndustries();
                this._updateRelatedIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.industry.id);
                this._updateFacebookTargetingBehavior();
                this._updateFacebookTargetinInterests();

                //SET ADVANCED TAB DEFAULT
                if(Object.keys(this.state.channels).filter((item) => {
                    return this.state.budget[item].search && this.state.channels[item].selected
                }).length > 0){
                    this.setState({advanced_tab: "search"});
                }else{
                    this.setState({advanced_tab: "social"});
                }

                //CHECK IF RELATED AND OPEN LIST
                if(this.state.related_industries.length > 0){
                    this.setState({related_open: this.state.related_industries.filter((item) => {return item.selected}).length > 0});
                }

                //SET BUDGET AUTO
                if(this.state.budget){
                    for (var key in this.state.budget) {
                        this.state.budget[key].auto = true;
                    }
                }

                /*TEMPORARY REMOVE LATER*/
                try {
                    if (this.state.keyword_languages.length < 1) {
                        let market = salesChannelRegister.get('market');
                        let langs = [];
                        if(market === "se"){
                            langs.push('sv');
                        }else{
                            langs.push('en');
                        }
                        cartRegister.setKeywordLanguages(langs);
                        this.setState({keyword_languages: langs});
                    }
                } catch (e) {
                }
                /*TEMPORARY REMOVE LATER*/

            })
        } else {
            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
        }
    }

    _updateTab() {
        if (this.props.location.search === "?tab=advanced") {
            this.setState({tab: "advanced"});
        }
    }

    _updateBudget(value) {
        if (value) {
            this.setState({budget: value}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _updateRelatedIndustries(market, lang, industry) {
        if (this.state.related_industries.length > 0) {
            //this._updateRegions(this.state.market);
            this.setState({
                isLoading: false
            });
        } else {
            dataRegister.related(market, lang, industry).then((data) => {
                this.setState({
                    related_industries: data
                }, () => {
                    cartRegister.setRelated(data);
                    //this._updateRegions(this.state.market);
                });
            }, (error) => {
                this.setState({error: true});
            });
        }
    }

    _updateSelectedRegions(regions, grid, init_regions){
        this.setState({regions_selected: regions, regions_grid: grid}, () => {
            cartRegister.setRegions(this.state.regions_selected);
            cartRegister.setRegionsGrid(this.state.regions_grid);

            //SKIP UPDATING BUDGET WHEN REGIONS IS FIRST LOADED
            if(!init_regions){
                this._updateNewBudget();
            }

        });
    }

    /*
    _updateRegions(market) {
        this.setState({regionLoader: true});
        let regions = this.state.regions_selected.map(function (item) {
            return item.id;
        }).join(",");
        dataRegister.regions(market, regions).then((data) => {
            if (data) {
                this.setState({regions: data.regions}, () => {
                    if (data.update.disabled) {
                        for (let m = 0; m < this.state.regions_selected.length; m++) {
                            for (let i = 0; i < data.update.disabled.length; i++) {
                                if (JSON.stringify(this.state.regions_selected[m].id) === data.update.disabled[i]) {
                                    this.state.regions_selected.splice(m, 1);
                                }
                            }
                        }
                    }
                    this.setState({
                        regions_selected: this.state.regions_selected,
                        regionLoader: false,
                        country: this.state.regions_selected.length === 1 && this.state.regions_selected[0].id === this.state.country_region.id
                    }, () => {
                        this._updateIndustries();
                        cartRegister.setRegions(this.state.regions_selected);
                    });
                });
            } else {
                this.setState({error: true});
            }
        }, (error) => {
            this.setState({error: true});
        });
    }
    */

    _updateIndustries(){
        dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.searchIndustry, 20).then((response) => {
            this.setState({industries: response, isLoading: false});
        }, (error) => {
            console.log(error);
        });
    }

    _updateSlogans(){
        let cart = cartRegister.getCheckout();
        if(cart.target_slogans){
            this.setState({slogans: cart.target_slogans});
        }else{
            this.setState({slogansLoader: true});
            dataRegister.quotes(this.state.industry.id, this.state.market, langRegister.lang()).then((data) => {
                if(!data.errors){
                    data = data.filter((item) => {
                        return item.type === "target"
                    });
                    this.setState({slogans: data, slogansLoader: false});
                }
            }, (error) => {
                this.setState({slogansLoader: false, error: true});
            });
        }
    }

    _updateFacebookTargeting(type){
        dataRegister.facebookTargeting(this.state.market, type, this.state.searchInterest).then((data) => {
            if(!data.errors){
                let list = [];
                let exist = false;
                for(let i = 0; i < data.length; i++){
                    exist = false;
                    for(let m = 0; m < this.state.interests_selected.length; m++){
                        if(this.state.interests_selected[m].id === data[i].id){
                            exist = true;
                            break;
                        }
                    }
                    if(!exist){
                        list.push(data[i]);
                    }
                }
                this.setState({interests: list});
            }
        }, (error) => {});
    }

    _updateFacebookTargetinInterests(){
        dataRegister.facebookTargeting(this.state.market, "interest", this.state.industry.name).then((data) => {
            if(!data.errors){
                for(let i = 0; i < data.length; i++){
                    for(let m = 0; m < this.state.interests_selected.length; m++){
                        if(this.state.interests_selected[m].id === data[i].id){
                            data[i].selected = true;
                            break;
                        }
                    }
                }
                let object = {};
                object[this.state.industry.name] = data;
                this.setState({interests_grid: object, show_interests_switch: data.length > 0});
            }
        }, (error) => {});
    }

    _updateFacebookTargetingBehavior(){
        dataRegister.facebookTargeting(this.state.market, "behavior", "").then((data) => {
            if(!data.errors){
                for(let i = 0; i < this.state.behaviors_selected.length; i++){
                    for(let m = 0; m < data.length; m++){
                        if(this.state.behaviors_selected[i].id === data[m].id){
                            data[m].hide = true;
                            data[m].selected = true;
                            break;
                        }
                    }
                }
                this.setState({behaviors: data}, () => {
                    let object = {};
                    for(let i = 0; i < this.state.behaviors.length; i++){
                        if(object[this.state.behaviors[i].path[0]]){
                            object[this.state.behaviors[i].path[0]].push(this.state.behaviors[i]);
                        }else{
                            object[this.state.behaviors[i].path[0]] = [];
                            object[this.state.behaviors[i].path[0]].push(this.state.behaviors[i]);
                        }
                    }
                    this.setState({behavior_grid: object});
                });
            }
        }, (error) => {});
    }

    _updateNewBudget() {
        if (this.state.regions_selected.length > 0) {
            
            let regions = this.state.regions_selected
                .map(function (item) {
                    return item.id;
                }).join(",");

            let related = this.state.related_industries.filter((item) => {
                return item.selected
            }).map(function (item) {
                return item.id;
            }).join(",");

            if(this.state.industries_selected.length > 0){

                let extra_related = this.state.industries_selected.map(function (item) {
                    return item.id;
                }).join(",");

                if(this.state.related_industries.filter((item) => {
                    return item.selected
                }).length > 0){
                    related = related+","+extra_related;
                }else{
                    related = extra_related;
                }

            }

            let industry = this.state.industry.id;
            let market_code = this.state.market;
            let duration = this.state.duration;
            let default_language = langRegister.lang();
            let optimization_goal = this.state.optimization_goal;

            dataRegister.budget(market_code, default_language, industry, regions, related, duration, optimization_goal).then((data) => {
                if (!data.errors) {
                    let budget = {};

                    //REMOVE LOCKIN
                    if("lockin_plans" in data){
                        this.state.lockin_plans = data.lockin_plans;
                        delete data.lockin_plans;
                        //PARSE LOCKIN PLANS
                        let plans = [];
                        let biggest_plan = {months: 0, free_months: 0};
                        if(this.state.lockin_plans.months && Array.isArray(this.state.lockin_plans.months)){
                            for(let i = 0; i < this.state.lockin_plans.months.length; i++){
                                let free_months = 0;
                                if(this.state.lockin_plans.months[i] > 5 && this.state.lockin_plans.months[i] < 12){
                                    free_months = 1;
                                }else if(this.state.lockin_plans.months[i] > 11){
                                    free_months = 2;
                                }
                                //SET BIGGEST PLAN AS DEFAULT
                                if(biggest_plan.months < this.state.lockin_plans.months[i]){
                                    biggest_plan = {"months": this.state.lockin_plans.months[i], "free_months": free_months};
                                }
                                plans.push({"months": this.state.lockin_plans.months[i], "free_months": free_months})
                            }
                            cartRegister.lockinPlans(plans);
                            cartRegister.setLockinPlan(biggest_plan);
                        }
                    }

                    // REMOVE SERVICE_FEE PROPERTIES
                    if ("service_fee_percentage" in data) {
                        this.state.service_fee_percentage = data.service_fee_percentage;
                        delete data.service_fee_percentage;
                    }
                    if ("service_fee_fixed" in data) {
                        this.state.service_fee_fixed = data.service_fee_fixed;
                        delete data.service_fee_fixed;
                    }

                    //REMOVE BUDGET DURAION
                    if("campaign_duration" in data){
                        delete data.campaign_duration;
                    }

                    this.setState({
                        service_fee_fixed: this.state.service_fee_fixed,
                        service_fee_percentage: this.state.service_fee_percentage,
                        lockin_plans: this.state.lockin_plans
                    });

                    for (let channel in data) {
                        if (channel === "fb") {
                            channel = "facebook";
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), "fb");
                        } else {
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), channel);
                        }
                    }

                    this.setState({
                        budget: budget,
                        error: false,
                        isLoading: false
                    }, () => {
                        cartRegister.setOfferServiceFeePercentage(this.state.service_fee_percentage);
                        cartRegister.setOfferServiceFeeFixed(this.state.service_fee_fixed);
                        cartRegister.setBudget(this.state.budget);
                    });

                } else {
                    this.setState({error: true});
                }
            }, (error) => {
                this.setState({error: true});
            });
        }
    }

    _reCalcBudgetTemp(data, channel) {

        //SET AUTO PROPERTY (ON)
        data[channel].auto = true;

        if(data[channel].social){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
            //data[channel].budget_total = data[channel].budget_cap;
        }

        if(data[channel].budget_available > data[channel].budget_cap){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
            //data[channel].budget_total = data[channel].budget_cap;
        }

        //SET INITIAL SPEND
        if (data[channel].budget_available > (data[channel].min_daily * this.state.duration)) {
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].budget_available;
        } else {
            data[channel].budget_available = data[channel].min_daily * this.state.duration;
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].min_daily * this.state.duration;
            //data[channel].budget_total = data[channel].min_daily * this.state.duration;
        }

        return data[channel];
    }

    _selectRelatedIndustry(prop) {
        prop.selected = !prop.selected;
        this.setState({
            related_industries: this.state.related_industries
        }, () => {
            cartRegister.setRelated(this.state.related_industries);
            this._updateNewBudget();
        });
    }

    _selectSlogan(prop){
        if(prop.selected){
            prop.selected = false;
        }else{
            this.state.slogans.map((item) => {
                item.selected = false;
            });
            prop.selected = true;
        }
        this.setState({
            slogans: this.state.slogans
        }, () => {
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setTargetSlogans(this.state.slogans);
        });
    }

    _selectDuration(value){
        this.setState({duration: value, isLoading: this.state.regions_selected.length > 0}, () => {
            cartRegister.setDuration(this.state.duration);
            if(this.state.regions_selected.length > 0){
                this._updateNewBudget(salesChannelRegister.get('market'), salesChannelRegister.get('default_language'), this.state.industry.id);
            }
        });
    }

    _selectTarget(prop) {
        prop.selected = !prop.selected;
        this.setState({targets: this.state.targets}, () => {
            let value = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    value = true;
                }
            }
            if (this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0 || value || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setTargets(this.state.targets);
        });
    }

    _selectRange(value) {
        let targets = false;
        for (let i = 0; i < this.state.targets.length; i++) {
            if (!this.state.targets[i].selected) {
                targets = true;
            }
        }
        this.setState({age_range: this.state.age_range}, () => {
            if (this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setAgeRange(this.state.age_range);
            cartRegister.setTargets(this.state.targets);
        })
    }

    _selectCountry() {
        let exist = false;
        let country = this.state.country_region;
        this.state.regions_selected = this.state.regions_selected.filter(function (item) {
            if (item.id !== country.id) {
                return item;
            } else {
                exist = true;
            }
        });
        if (!exist) {
            this.state.regions_selected.push(country);
        }
        this.setState({
            regions_selected: this.state.regions_selected
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _selectKeywordLanguage(item) {
        let exist = false;
        for (let i = 0; i < this.state.keyword_languages.length; i++) {
            if (this.state.keyword_languages[i] === item) {
                this.state.keyword_languages.splice(i, 1);
                exist = true;
                break;
            }
        }
        if (!exist) {
            this.state.keyword_languages.push(item);
        }

        let targets = false;
        for (let i = 0; i < this.state.targets.length; i++) {
            if (!this.state.targets[i].selected) {
                targets = true;
            }
        }
        if (this.state.keyword_languages.length > 1 || this.state.slogans.filter((item) => {
            return item.selected
        }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0) {
            cartRegister.setPlan(marketRegister.highPlan());
            this.setState({plan: marketRegister.highPlan()});
        } else {
            cartRegister.setPlan(marketRegister.lowPlan());
            cartRegister.setTargets(null);
            this.setState({plan: marketRegister.lowPlan()});
        }

        this.setState({keyword_languages: this.state.keyword_languages}, () => {
            cartRegister.setKeywordLanguages(this.state.keyword_languages);
        });
    }

    _selectRegion(prop) {
        this.state.regions_selected.push(prop);
        this.setState({
            regions_selected: this.state.regions_selected,
            search: ""
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _selectInterest(prop){
        this.state.interests_selected.push(prop);
        if(this.state.industry.name){
            let key = this.state.industry.name;
            for(let i = 0; i < this.state.interests_grid[key].length; i++){
                if(this.state.interests_grid[key][i].id === prop.id){
                    this.state.interests_grid[key][i].selected = true;
                }
            }
        }
        this.setState({interests_selected: this.state.interests_selected, searchInterest: "", interests: []}, () => {
            cartRegister.setPlan(marketRegister.highPlan());
            this.setState({plan: marketRegister.highPlan()});
            cartRegister.setInterests(this.state.interests_selected);
        });
    }

    _selectBehavior(prop){
        this.state.behaviors_selected.push(prop);
        for(let i = 0; i < this.state.behaviors.length; i++){
            if(this.state.behaviors[i].id === prop.id){
                this.state.behaviors[i].hide = true;
                this.state.behaviors[i].selected = true;
            }
        }
        this.setState({behaviors_selected: this.state.behaviors_selected, searchBehavior: "", behaviors: this.state.behaviors}, () => {
            cartRegister.setPlan(marketRegister.highPlan());
            this.setState({plan: marketRegister.highPlan()});
            cartRegister.setBehaviors(this.state.behaviors_selected);
        });
    }

    _selectIndustry(prop){
        let exist = false;
        try{
            for(let i = 0; i < this.state.industries_selected.length; i++){
                if(this.state.industries_selected[i].id === prop.id){
                    exist = true;
                    break;
                }
            }
        }catch (e) {}
        if(!exist){
            this.state.industries_selected.push(prop);
            this.setState({industries_selected: this.state.industries_selected, searchIndustry: ""}, () => {
                cartRegister.setExtraIndustries(this.state.industries_selected);
                this._updateNewBudget();
            });
        }
    }

    _removeRegion(prop) {
        this.setState({
            regions_selected: this.state.regions_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _removeInterest(prop) {
        this.setState({
            interests_selected: this.state.interests_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            if(this.state.industry.name){
                let key = this.state.industry.name;
                for(let i = 0; i < this.state.interests_grid[key].length; i++){
                    if(this.state.interests_grid[key][i].id === prop.id){
                        this.state.interests_grid[key][i].selected = false;
                    }
                }
            }
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setInterests(this.state.interests_selected);
        });
    }

    _removeBehavior(prop) {
        this.setState({
            behaviors_selected: this.state.behaviors_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            for(let i = 0; i < this.state.behaviors.length; i++){
                if(this.state.behaviors[i].id === prop.id){
                    this.state.behaviors[i].hide = false;
                    this.state.behaviors[i].selected = false;
                }
            }
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.behaviors_selected.length > 0 || this.state.interests_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setBehaviors(this.state.behaviors_selected);
        });
    }

    _removeIndustry(prop) {
        this.setState({
            industries_selected: this.state.industries_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            cartRegister.setExtraIndustries(this.state.industries_selected);
            this._updateNewBudget();
        });
    }

    _checkout() {
        if (this.state.regions_selected.length > 0 && this.state.targets.filter((item) => {
            return item.selected
        }).length > 0) {
            cartRegister.setAdLanguage(this.state.language);
            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/budget");
        }
    }

    _back() {
        cartRegister.setAdLanguage(this.state.language);
        this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/ads");
    }

    _filterRegions(search) {
        let industries = [];
        let exact = [];
        let first = [];
        let contains = [];
        let pattern = new RegExp('^' + search.toLowerCase());
        for (let i = 0; i < this.state.regions.length; i++) {
            if (this.state.regions[i].name.toLowerCase() === search.toLowerCase()) {
                exact.push(this.state.regions[i]);
            } else if (this.state.regions[i].name.toLowerCase().indexOf(search.toLowerCase()) !== 1 && !pattern.test(this.state.regions[i].name.toLowerCase())) {
                contains.push(this.state.regions[i]);
            } else if (pattern.test(this.state.regions[i].name.toLowerCase())) {
                first.push(this.state.regions[i]);
            }
        }
        industries = exact.concat(first, contains);
        return industries;
    }

    _filterIndustries(search) {
        try{
            let industries = [];
            let exact = [];
            let first = [];
            let contains = [];
            let pattern = new RegExp('^' + this.state.searchIndustry.toLowerCase());
            let list = JSON.parse(JSON.stringify(this.state.industries));

            for(let i = 0; i < list.length; i++){
                for(let m = 0; m < this.state.industries_selected.length; m++){
                    try{
                        if(this.state.industries_selected[m].id === list[i].id){
                            list.splice(i, 1);
                        }
                    }catch (e) {}
                }
                for(let n = 0; n < this.state.related_industries.length; n++){
                    try{
                        if(this.state.related_industries[n].id === list[i].id){
                            list.splice(i, 1);
                        }
                    }catch (e) {}
                }
                try{
                    if(this.state.industry.id === list[i].id){
                        list.splice(i, 1);
                    }
                }catch (e) {}
            }

            for (let i = 0; i < list.length; i++) {
                if (list[i].name.toLowerCase() === this.state.searchIndustry.toLowerCase()) {
                    exact.push(list[i]);
                } else if (list[i].name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== 1 && !pattern.test(list[i].name.toLowerCase())) {
                    contains.push(list[i]);
                } else if (pattern.test(list[i].name.toLowerCase())) {
                    first.push(list[i]);
                }
            }
            industries = exact.concat(first, contains);
            return industries;
        }catch (e) {
            return [];
        }
    }

    _renderAdLanguages(){
        for(let i = 0; i < this.state.ad_languages.length; i++){
            if(this.state.ad_languages[i].value === this.state.language){
                return(
                    <div className={Styles.checkMarksContainer}>
                        <div className={Styles.checkMarksContainerItem}>
                            <img src={require("../../assets/images/checkmark-disabled.svg")}
                                 className={Styles.checkMarksContainerItemIcon}/>
                            <div className={Styles.checkMarksContainerItemText}>
                                {this.state.ad_languages[i].title[langRegister.lang()]}
                            </div>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className={Styles.checkMarksContainer}>
                        <div className={Styles.checkMarksContainerItem}>
                            <img src={require("../../assets/images/checkmark_new.svg")}
                                 className={Styles.checkMarksContainerItemIcon}/>
                            <div className={Styles.checkMarksContainerItemText}>
                                {this.state.ad_languages[i].title[langRegister.lang()]}
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget) {
            if (this.state.regions_selected.length > 0) {
                for (let key in this.state.channels) {
                    if (this.state.channels[key].selected) {
                        impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
                    }
                }
                return Math.ceil(impressions);
            } else {
                return 0;
            }
        } else {
            return ("...");
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget) {
            if (this.state.regions_selected.length > 0) {
                for (let key in this.state.channels) {
                    if (this.state.channels[key].selected) {
                        clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
                    }
                }
                return Math.ceil(clicks);
            } else {
                return 0;
            }
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels && this.state.regions_selected.length > 0) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            /*
            //IF VAT
            if(this.state.vat){
                budget = budget + this._renderVat();
            }
            */

            return budget;
        }else{
            return 0;
        }
    }

    _renderPercentageFee() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            return budget * (this.state.service_fee_percentage / 100);
        }
    }

    _renderVat() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this._renderPercentageFee();
            }

            return budget * (this.state.vat / 100);
        }
    }

    renderKeywordLanguages() {
        let list = [];
        try {
            if (this.state.available_keyword_languages.google && this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.google.concat(this.state.available_keyword_languages.bing);
                const final = [];
                list.map((e, i) => !final.includes(e) && final.push(e));
                list = final;
            } else if (this.state.available_keyword_languages.google && !this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.google;
            } else if (!this.state.available_keyword_languages.google && this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.bing;
            }

            for (let i = 0; i < list.length; i++) {
                try {
                    list[i] = this.renderKeywordLanguageTitle(list[i]);
                } catch (e) {
                }
            }

            return list

        } catch (e) {
            return list;
        }
    }

    renderKeywordLanguageAvailable(item) {
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska'}
        };
        return items[item];
    }

    renderKeywordLanguage(item) {
        try {
            let selected = false;
            for (let i = 0; i < this.state.keyword_languages.length; i++) {
                if (this.state.keyword_languages[i] === item) {
                    selected = true;
                    break;
                }
            }
            return selected;
        } catch (e) {}
    }

    renderKeywordLanguageTitle(item) {
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska', 'code': 'en'},
            'ar': {'en': 'Arabic', 'sv': 'Arabiska', 'code': 'ar'},
            'fi': {'en': 'Finnish', 'sv': 'Finska', 'code': 'fi'},
            'de': {'en': 'German', 'sv': 'Tyska', 'code': 'de'},
            'zh': {'en': 'Chinese', 'sv': 'Kinesiska', 'code': 'zh'},
            'tr': {'en': 'Turkish', 'sv': 'Turkiska', 'code': 'tr'},
            'es': {'en': 'Spanish', 'sv': 'Spanska', 'code': 'es'},
            'el': {'en': 'Greek', 'sv': 'Grekiska', 'code': 'el'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska', 'code': 'sv'},
            'cs': {'en': 'Czech', 'sv': 'Tjeckiska', 'code': 'cs'},
            'da': {'en': 'Danish', 'sv': 'Danska', 'code': 'da'},
            'mt': {'en': 'Maltese', 'sv': 'Maltesisk', 'code': 'mt'},
            'hr': {'en': 'Croatian', 'sv': 'Kroatisk', 'code': 'hr'},
            'pa': {'en': 'Punjabi', 'sv': 'Punjabi', 'code': 'pa'},
            'fr': {'en': 'French', 'sv': 'Franska', 'code': 'fr'},
            'nl': {'en': 'Dutch', 'sv': 'Holländska', 'code': 'nl'},
            'ko': {'en': 'Korean', 'sv': 'Koreanska', 'code': 'ko'},
            'hi': {'en': 'Hindi', 'sv': 'Hindi', 'code': 'hi'},
            'pt': {'en': 'Portuguese', 'sv': 'Portugisiska', 'code': 'pt'},
            'ur': {'en': 'Urdu', 'sv': 'Urdu', 'code': 'ur'},
            'it': {'en': 'Italian', 'sv': 'Italienska', 'code': 'it'},
            'ru': {'en': 'Russian', 'sv': 'Ryska', 'code': 'ru'},
            'pl': {'en': 'Polish', 'sv': 'Polska', 'code': 'pl'},
            'ja': {'en': 'Japanese', 'sv': 'Japanska', 'code': 'ja'},
            'sr': {'en': 'Serbian', 'sv': 'Serb', 'code': 'sr'},
            'ms': {'en': 'Malay', 'sv': 'Malay', 'code': 'ms'}
        };
        try {
            return items[item];
        } catch (e) {
            return item;
        }
    }

    renderKeywordLanguageDisabled(item) {
        let items = {};
        let market = salesChannelRegister.get('market');
        if(market === "se"){
            items = {sv: 'sv'};
        }else{
            items = {en: 'en'};
        }
        return items[item];
    }

    _renderInterestPath(path){
        let string = "";
        for(let i = 0; i < path.length - 1; i++){
            if(i !== path.length - 2){
                string = string + path[i] + " - ";
            }else{
                string = string + path[i];
            }
        }
        return string;
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-filter", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupTwo props={this.props} step={2}/>
                {
                    this.state.industry && this.state.channels && this.state.regions && this.state.budget && this.state.market && !this.state.isLoading && this.state.plan && this.state.currency && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.title)}>
                            {this._renderText("item_1")}
                        </div>
                        <div className={Styles.containerInner}>
                            <div className={Styles.left}>
                                {
                                    <div className={
                                        cx(Styles.tabsContainer,
                                            {
                                                [Styles.tabsContainerBasic]: this.state.tab === "basic" && Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length > 0,
                                                [Styles.tabsContainerNoExtra]: Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length < 1 || Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length < 1
                                            })
                                    }>
                                        <div onClick={() => this.setState({tab: "basic"})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "basic",
                                                })
                                        }>
                                            {this._renderText("item_2")}
                                        </div>
                                        <div onClick={() => this.setState({tab: "advanced"})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "advanced",
                                                })
                                        }>
                                            {this._renderText("item_3")}
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.tab === "advanced" && Object.keys(this.state.channels).filter((item) => {
                                        return this.state.budget[item].social && this.state.channels[item].selected
                                    }).length > 0 && Object.keys(this.state.channels).filter((item) => {
                                        return this.state.budget[item].search && this.state.channels[item].selected
                                    }).length > 0 &&
                                    <div className={Styles.tabsContainerOpposite}>
                                        {
                                            <div onClick={() => this.setState({advanced_tab: "search"})} className={
                                                cx(Styles.tabsContainerItemOpposite,
                                                    {
                                                        [Styles.tabsContainerItemActive]: this.state.advanced_tab === "search",
                                                    })
                                            }>
                                                {this._renderText("item_51")}
                                            </div>
                                        }
                                        {
                                            <div onClick={() => this.setState({advanced_tab: "social"})} className={
                                                cx(Styles.tabsContainerItemOpposite,
                                                    {
                                                        [Styles.tabsContainerItemActive]: this.state.advanced_tab === "social",
                                                    })
                                            }>
                                                {this._renderText("item_50")}
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    this.state.tab === "advanced" &&
                                    <div>
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" &&
                                            <div className={Styles.subTitle}>
                                                {this._renderText("item_27")}
                                                {
                                                    false &&
                                                    <img src={require("../../assets/images/info_icon.svg")}
                                                         className={Styles.subTitleIcon}/>
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" &&
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.state.targets.map((prop, i) => {
                                                        return (
                                                            <div onClick={() => this._selectTarget(prop)} key={i}
                                                                 className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !prop.selected &&
                                                                    <img
                                                                        src={require("../../assets/images/checkmark_new.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    prop.selected &&
                                                                    <img
                                                                        src={require("../../assets/images/square_checkmark_active.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div
                                                                    className={Styles.checkMarksContainerItemText}>
                                                                    {prop.title}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" &&
                                            <div className={Styles.subTitle}>
                                                {this._renderText("item_28")}
                                                {
                                                    false &&
                                                    <img src={require("../../assets/images/info_icon.svg")}
                                                         className={Styles.subTitleIcon}/>
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" &&
                                            <div className={Styles.sliderRangeContainer}>
                                                <div className={Styles.sliderRangeContainerValue}>
                                                    <input readOnly={true} value={this.state.age_range[0]}
                                                           className={Styles.sliderRangeContainerValueInput}/>
                                                </div>
                                                <div className={Styles.sliderRangeContainerSlider}>
                                                    <Range
                                                        defaultValue={[18, 65]}
                                                        trackStyle={[{backgroundColor: '#41CBC7'}]}
                                                        min={13}
                                                        max={65}
                                                        value={this.state.age_range}
                                                        onChange={(value) => {
                                                            this.state.age_range = value;
                                                            this._selectRange()
                                                        }}
                                                    />
                                                </div>
                                                <div className={Styles.sliderRangeContainerValue}>
                                                    <input readOnly={true} value={this.state.age_range[1]>64?this.state.age_range[1] + "+":this.state.age_range[1]} className={Styles.sliderRangeContainerValueInput}/>
                                                </div>
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) &&
                                            <div className={Styles.subTitle}>
                                                <div className={Styles.subTitleLeft}>
                                                    {this._renderText("item_46")}
                                                </div>
                                                {
                                                    this.state.show_interests_switch &&
                                                    <div className={Styles.subTitleRight}>
                                                        {
                                                            <img onClick={() => {this.setState({interests_switch: false})}}
                                                                 className={Styles.subTitleRightIcon}
                                                                 src={require("../../assets/images/list_icon.svg")}/>
                                                        }
                                                        {
                                                            this.state.interests_switch &&
                                                            <img onClick={() => {this.setState({interests_switch: false})}}
                                                                 className={Styles.subTitleRightSwitch}
                                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                                        }
                                                        {
                                                            !this.state.interests_switch &&
                                                            <img onClick={() => {this.setState({interests_switch: true})}}
                                                                 className={Styles.subTitleRightSwitch}
                                                                 src={require("../../assets/images/push_black_off.svg")}/>
                                                        }
                                                        {
                                                            <img onClick={() => {this.setState({interests_switch: true})}}
                                                                 className={Styles.subTitleRightIcon}
                                                                 src={require("../../assets/images/grid_icon.svg")}/>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.interests_switch &&
                                            <div className={Styles.inputContainer}>
                                                {
                                                    this.state.regionLoader &&
                                                    <div className={Styles.inputContainerLoader}>
                                                        <BeatLoader size={15} color={'#41CBC7'} loading={true}/>
                                                    </div>
                                                }
                                                <input onFocus={() => this.setState({dropdown: true})}
                                                       onBlur={() => this.setState({dropdown: false})}
                                                       value={this.state.searchInterest}
                                                       onChange={(event) => {
                                                           this.setState({searchInterest: event.target.value}, () => {
                                                               this._updateFacebookTargeting("interest")
                                                           })
                                                       }}
                                                       placeholder={this._renderText("item_47")}
                                                       className={
                                                           cx(Styles.input, Styles.inputLong)
                                                       }
                                                />
                                                {
                                                    this.state.dropdown && this.state.interests.length > 0 &&
                                                    <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                        {
                                                            this.state.interests.map((prop, key) => {
                                                                return (
                                                                    <div key={key}
                                                                         onMouseDown={() => this._selectInterest(prop)}
                                                                         className={cx(Styles.inputDropdownItem, Styles.inputDropdownItemExtraSpace)}>
                                                                        <div>
                                                                            {prop.name}
                                                                        </div>
                                                                        <div className={Styles.inputDropdownItemDescripton}>{this._renderInterestPath(prop.path)}</div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.interests_switch &&
                                            <div className={Styles.regionsContainer}>
                                                {
                                                    this.state.interests_selected.map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.regionsContainerItem}>
                                                                <div className={Styles.regionsContainerItemTitle}>
                                                                    {prop.name}
                                                                </div>
                                                                <img onClick={() => this._removeInterest(prop)}
                                                                     src={require("../../assets/images/small_cross_white.png")}
                                                                     className={Styles.regionsContainerItemIcon}
                                                                />
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && this.state.interests_switch &&
                                            <div>
                                                {
                                                    Object.keys(this.state.interests_grid).map((key, i) => {
                                                        return(
                                                            <div>
                                                                {
                                                                    <div className={Styles.subTitleSmall}>
                                                                        <div className={Styles.subTitleLeft}>
                                                                            {key}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className={Styles.checkMarksContainer}>
                                                                    {
                                                                        this.state.interests_grid[key].map((prop, i) => {
                                                                            return (
                                                                                <div key={i} className={Styles.checkMarksContainerItemSmall}>
                                                                                    {
                                                                                        !prop.selected &&
                                                                                        <img onClick={() => this._selectInterest(prop, key)}
                                                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    {
                                                                                        prop.selected &&
                                                                                        <img onClick={() => this._removeInterest(prop, key)}
                                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    <div onClick={() => {
                                                                                        if(prop.selected){
                                                                                            this._removeInterest(prop, key)
                                                                                        }else{
                                                                                            this._selectInterest(prop, key)
                                                                                        }
                                                                                    }} className={Styles.checkMarksContainerItemText}>
                                                                                        {prop.name}
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) &&
                                            <div className={Styles.subTitle}>
                                                <div className={Styles.subTitleLeft}>
                                                    {this._renderText("item_52")}
                                                </div>
                                                <div className={Styles.subTitleRight}>
                                                    {
                                                        <img onClick={() => {this.setState({behaviors_switch: false})}}
                                                             className={Styles.subTitleRightIcon}
                                                             src={require("../../assets/images/list_icon.svg")}/>
                                                    }
                                                    {
                                                        this.state.behaviors_switch &&
                                                        <img onClick={() => {this.setState({behaviors_switch: false})}}
                                                             className={Styles.subTitleRightSwitch}
                                                             src={require("../../assets/images/push_black_on.svg")}/>
                                                    }
                                                    {
                                                        !this.state.behaviors_switch &&
                                                        <img onClick={() => {this.setState({behaviors_switch: true})}}
                                                             className={Styles.subTitleRightSwitch}
                                                             src={require("../../assets/images/push_black_off.svg")}/>
                                                    }
                                                    {
                                                        <img onClick={() => {this.setState({behaviors_switch: true})}}
                                                             className={Styles.subTitleRightIcon}
                                                             src={require("../../assets/images/grid_icon.svg")}/>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.behaviors_switch &&
                                            <div className={Styles.inputContainer}>
                                                {
                                                    this.state.regionLoader &&
                                                    <div className={Styles.inputContainerLoader}>
                                                        <BeatLoader size={15} color={'#41CBC7'} loading={true}/>
                                                    </div>
                                                }
                                                <input onFocus={() => this.setState({dropdownBehavior: true})}
                                                       onBlur={() => this.setState({dropdownBehavior: false})}
                                                       value={this.state.searchBehavior}
                                                       onChange={(event) => {
                                                           this.setState({searchBehavior: event.target.value})
                                                       }}
                                                       placeholder={this._renderText("item_53")}
                                                       className={
                                                           cx(Styles.input, Styles.inputLong)
                                                       }
                                                />
                                                {
                                                    this.state.dropdownBehavior && this.state.behaviors.length > 0 &&
                                                    <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                        {
                                                            this.state.behaviors.filter((item) => {
                                                                return item.name.toLowerCase().indexOf(this.state.searchBehavior.toLowerCase()) !== -1 && !item.hide
                                                            }).map((prop, key) => {
                                                                return (
                                                                    <div key={key}
                                                                         onMouseDown={() => this._selectBehavior(prop)}
                                                                         className={cx(Styles.inputDropdownItem, Styles.inputDropdownItemExtraSpace)}>
                                                                        <div>
                                                                            {prop.name}
                                                                        </div>
                                                                        <div className={Styles.inputDropdownItemDescripton}>{prop.description}</div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.behaviors_switch &&
                                            <div className={Styles.regionsContainer}>
                                                {
                                                    this.state.behaviors_selected.map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.regionsContainerItem}>
                                                                <div className={Styles.regionsContainerItemTitle}>
                                                                    {prop.name}
                                                                </div>
                                                                <img onClick={() => this._removeBehavior(prop)}
                                                                     src={require("../../assets/images/small_cross_white.png")}
                                                                     className={Styles.regionsContainerItemIcon}
                                                                />
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].social && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && this.state.behaviors_switch &&
                                            <div>
                                                {
                                                    Object.keys(this.state.behavior_grid).map((key, i) => {
                                                        return(
                                                            <div>
                                                                {
                                                                    <div className={Styles.subTitleSmall}>
                                                                        <div className={Styles.subTitleLeft}>
                                                                            {key}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className={Styles.checkMarksContainer}>
                                                                    {
                                                                        this.state.behavior_grid[key].map((prop, i) => {
                                                                            return (
                                                                                <div key={i} className={Styles.checkMarksContainerItemSmall}>
                                                                                    {
                                                                                        !prop.selected &&
                                                                                        <img onClick={() => this._selectBehavior(prop)}
                                                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    {
                                                                                        prop.selected &&
                                                                                        <img onClick={() => this._removeBehavior(prop)}
                                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                                    }
                                                                                    <div onClick={() => {
                                                                                        if(prop.selected){
                                                                                            this._removeBehavior(prop)
                                                                                        }else{
                                                                                            this._selectBehavior(prop)
                                                                                        }
                                                                                    }} className={Styles.checkMarksContainerItemText}>
                                                                                        {prop.name}
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].search && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "search" &&
                                            <div className={Styles.subTitle}>
                                                {this._renderText("item_54")}
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].search && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "search" &&
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.renderKeywordLanguages()
                                                        .sort(function (a, b) {
                                                            try {
                                                                if (a[langRegister.lang()] < b[langRegister.lang()]) {
                                                                    return -1;
                                                                }
                                                                if (a[langRegister.lang()] > b[langRegister.lang()]) {
                                                                    return 1;
                                                                }
                                                                return 0;
                                                            } catch (e) {
                                                                return 0;
                                                            }
                                                        }).map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !this.renderKeywordLanguage(prop.code) && !this.renderKeywordLanguageDisabled(prop.code) &&
                                                                    <img
                                                                        onClick={() => this._selectKeywordLanguage(prop.code)}
                                                                        src={require("../../assets/images/checkmark_new.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    this.renderKeywordLanguage(prop.code) && !this.renderKeywordLanguageDisabled(prop.code) &&
                                                                    <img
                                                                        onClick={() => this._selectKeywordLanguage(prop.code)}
                                                                        src={require("../../assets/images/square_checkmark_active.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    this.renderKeywordLanguageDisabled(prop.code) &&
                                                                    <img
                                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div onClick={() => {
                                                                    if (!this.renderKeywordLanguageDisabled(prop.code)) {
                                                                        this._selectKeywordLanguage(prop.code)
                                                                    }
                                                                }}
                                                                     className={Styles.checkMarksContainerItemText}>
                                                                    {prop[langRegister.lang()]}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].search && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "search" &&
                                            <div className={Styles.subTitle}>
                                                {this._renderText("item_45")}
                                            </div>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].search && this.state.channels[item].selected
                                            }).length > 0 && this.state.advanced_tab === "search" &&
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.state.slogans.map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !prop.selected &&
                                                                    <img onClick={() => this._selectSlogan(prop)}
                                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    prop.selected &&
                                                                    <img onClick={() => this._selectSlogan(prop)}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div onClick={() => this._selectSlogan(prop)}
                                                                     className={Styles.checkMarksContainerItemText}>
                                                                    {prop.slogan}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    this.state.tab === "basic" &&
                                    <div>
                                        <div className={
                                            cx(Styles.subTitle)
                                        }>
                                            {this._renderText("item_31")}
                                        </div>
                                        {
                                            this._renderAdLanguages()
                                        }
                                        <div className={Styles.subTitle}>
                                            <div className={Styles.subTitleLeft}>
                                                {this._renderText("item_6")}
                                            </div>
                                            <div className={Styles.subTitleRight}>
                                                {
                                                    <img onClick={() => {this.setState({region_switch: false})}}
                                                         className={Styles.subTitleRightIcon}
                                                         src={require("../../assets/images/list_icon.svg")}/>
                                                }
                                                {
                                                    this.state.region_switch &&
                                                    <img onClick={() => {this.setState({region_switch: false})}}
                                                         className={Styles.subTitleRightSwitch}
                                                         src={require("../../assets/images/push_black_on.svg")}/>
                                                }
                                                {
                                                    !this.state.region_switch &&
                                                    <img onClick={() => {this.setState({region_switch: true})}}
                                                         className={Styles.subTitleRightSwitch}
                                                         src={require("../../assets/images/push_black_off.svg")}/>
                                                }
                                                {
                                                    <img onClick={() => {this.setState({region_switch: true})}}
                                                         className={Styles.subTitleRightIcon}
                                                         src={require("../../assets/images/grid_icon.svg")}/>
                                                }
                                            </div>
                                        </div>
                                        <RegionSearch updateSwitch={this.state.region_switch} updateSelectedRegions={this._updateSelectedRegions}/>
                                        {
                                            <span>
                                            <div className={Styles.subTitleNormal}>{this._renderText("item_4")}
                                                <span className={Styles.subTitleBold}>{" "}{this.state.industry.name}</span>,
                                                {this._renderText("item_5")}
                                                {
                                                    false &&
                                                    <img src={require("../../assets/images/info_icon.svg")}
                                                         className={Styles.subTitleIcon}/>
                                                }
                                            </div>
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.state.related_industries.sort(function (a, b) {
                                                        if (a.name < b.name) {
                                                            return -1;
                                                        }
                                                        if (a.name > b.name) {
                                                            return 1;
                                                        }
                                                        return 0;
                                                    }).filter((item, i) => {
                                                        if((i < this.state.count * this.state.page) || this.state.related_open){
                                                            return item
                                                        }
                                                    }).map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !prop.selected &&
                                                                    <img onClick={() => this._selectRelatedIndustry(prop)}
                                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    prop.selected &&
                                                                    <img onClick={() => this._selectRelatedIndustry(prop)}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div onClick={() => this._selectRelatedIndustry(prop)}
                                                                     className={Styles.checkMarksContainerItemText}>
                                                                    {prop.name}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                {
                                                    this.state.related_industries.length > (this.state.count * this.state.page) && !this.state.related_open &&
                                                    <div onClick={() => {
                                                        this.setState({page: this.state.page + 1 });
                                                    }} className={Styles.checkMarksContainerPlus}>
                                                        <img
                                                            className={Styles.checkMarksContainerPlusIcon}
                                                            src={require("../../assets/images/plus_sign_white_small.png")}/>
                                                    </div>
                                                }
                                            </div>
                                        </span>
                                        }
                                        <div className={
                                            cx(Styles.subTitle)
                                        }>
                                            <div className={Styles.subTitleLeft}>
                                                {this._renderText("item_48")}
                                            </div>
                                        </div>
                                        {
                                            <div className={Styles.inputContainer}>
                                                <input onFocus={() => this.setState({dropdown_industry: true})}
                                                       onBlur={() => this.setState({dropdown_industry: false})}
                                                       value={this.state.searchIndustry}
                                                       onChange={(event) => {
                                                           this.setState({searchIndustry: event.target.value}, () => {
                                                               this._updateIndustries();
                                                           })
                                                       }}
                                                       placeholder={this._renderText("item_49")}
                                                       className={
                                                           cx(Styles.input, Styles.inputLong)
                                                       }
                                                />
                                                {
                                                    this.state.dropdown_industry && this._filterIndustries(this.state.searchIndustry).filter((item) => {
                                                        return item.name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== -1
                                                    }).length > 0 &&
                                                    <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                        {
                                                            this._filterIndustries(this.state.searchIndustry).filter((item) => {
                                                                return item.name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== -1
                                                            }).map((prop, key) => {
                                                                return (
                                                                    <div key={key}
                                                                         onMouseDown={() => this._selectIndustry(prop)}
                                                                         className={Styles.inputDropdownItem}>
                                                                        {prop.name}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            <div className={Styles.regionsContainer}>
                                                {
                                                    this.state.industries_selected.map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.regionsContainerItem}>
                                                                <div className={Styles.regionsContainerItemTitle}>
                                                                    {prop.name}
                                                                </div>
                                                                <img onClick={() => this._removeIndustry(prop)}
                                                                     src={require("../../assets/images/small_cross_white.png")}
                                                                     className={Styles.regionsContainerItemIcon}
                                                                />
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </div>
                                        }

                                    </div>
                                }
                                <div className={Styles.divider}/>
                                <div onClick={() => this._checkout()}
                                     className={
                                         cx(Styles.button,
                                             {
                                                 [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                 && this.state.targets.filter((item) => {
                                                     return item.selected
                                                 }).length > 0,
                                             })
                                     }>
                                    {this._renderText("item_14")}
                                    <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toLowerCase()}
                                    </span>
                                    {
                                        this.state.regions_selected.length < 1 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_33")}</span>
                                    }
                                    {
                                        this.state.targets.filter((item) => {
                                            return item.selected
                                        }).length < 1
                                        && this.state.regions_selected.length > 0 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_42")}</span>
                                    }
                                    {
                                        Object.keys(this.state.channels).filter((item) => {
                                            return this.state.channels[item].selected && this.state.budget[item].low_traffic_flag && this.state.budget[item].search
                                        }).length > 0 && this.state.regions_selected.length > 0
                                        && this.state.targets.filter((item) => {
                                            return item.selected
                                        }).length > 0 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_32")}</span>
                                    }
                                </div>
                                <div onClick={() => {
                                    this._back()
                                }} className={Styles.backButton}>
                                    {this._renderText("item_23")}
                                </div>
                            </div>
                            <div className={Styles.right}>

                                <div className={Styles.contentContainerRightInner}>
                                    <Basket updateBudget={this._updateBudget}
                                            selectDuration={this._selectDuration}
                                            props={this.props}
                                            duration={this.state.duration}
                                            durations={this.state.durations}
                                            nextView={"/signup/budget"}
                                            serviceFeeFixed={this.state.service_fee_fixed}
                                            serviceFeePercentage={this.state.service_fee_percentage}
                                            regions={this.state.regions_selected} budget={this.state.budget}
                                            channels={this.state.channels} currency={this.state.currency}
                                            plan={this.state.plan} vat={this.state.vat} duration={this.state.duration}/>
                                    <div onClick={() => this._checkout()} className={
                                        cx(Styles.contentContainerRightButton,
                                            {
                                                [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                && this.state.targets.filter((item) => {
                                                    return item.selected
                                                }).length > 0
                                            })
                                    }>
                                        {this._renderText("item_14")}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }

    /*
    render() {
        return (
            <div>
                <HeaderSignupTwo props={this.props} step={2}/>
                {
                    this.state.industry && this.state.channels && this.state.regions && this.state.budget && this.state.market && !this.state.isLoading && this.state.plan && this.state.currency && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.title)}>
                            {this._renderText("item_1")}
                        </div>
                        <div className={Styles.containerInner}>
                            <div className={Styles.left}>
                                {
                                    Object.keys(this.state.channels).filter((item) => {
                                        return this.state.budget[item].social && this.state.channels[item].selected
                                    }).length > 0 &&
                                    <div className={Styles.tabsContainer}>
                                        <div onClick={() => this.setState({tab: "basic"})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "basic",
                                                })
                                        }>
                                            {this._renderText("item_2")}
                                        </div>
                                        <div onClick={() => this.setState({tab: "advanced"})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "advanced",
                                                })
                                        }>
                                            {this._renderText("item_3")}
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.tab === "advanced" &&
                                    <div>
                                        <div className={Styles.subTitle}>
                                            {this._renderText("item_27")}
                                            {
                                                false &&
                                                <img src={require("../../assets/images/info_icon.svg")}
                                                     className={Styles.subTitleIcon}/>
                                            }
                                        </div>
                                        <div className={Styles.checkMarksContainer}>
                                            {
                                                this.state.targets.map((prop, i) => {
                                                    return (
                                                        <div onClick={() => this._selectTarget(prop)} key={i}
                                                             className={Styles.checkMarksContainerItem}>
                                                            {
                                                                !prop.selected &&
                                                                <img
                                                                    src={require("../../assets/images/checkmark_new.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon}/>
                                                            }
                                                            {
                                                                prop.selected &&
                                                                <img
                                                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon}/>
                                                            }
                                                            <div
                                                                className={Styles.checkMarksContainerItemText}>
                                                                {prop.title}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className={Styles.subTitle}>
                                            {this._renderText("item_28")}
                                            {
                                                false &&
                                                <img src={require("../../assets/images/info_icon.svg")}
                                                     className={Styles.subTitleIcon}/>
                                            }
                                        </div>
                                        <div className={Styles.sliderRangeContainer}>
                                            <div className={Styles.sliderRangeContainerValue}>
                                                <input readOnly={true} value={this.state.age_range[0]}
                                                       className={Styles.sliderRangeContainerValueInput}/>
                                            </div>
                                            <div className={Styles.sliderRangeContainerSlider}>
                                                <Range
                                                    defaultValue={[13, 65]}
                                                    trackStyle={[{backgroundColor: '#41CBC7'}]}
                                                    min={13}
                                                    max={65}
                                                    value={this.state.age_range}
                                                    onChange={(value) => {
                                                        this.state.age_range = value;
                                                        this._selectRange()
                                                    }}
                                                />
                                            </div>
                                            <div className={Styles.sliderRangeContainerValue}>
                                                <input readOnly={true} value={this.state.age_range[1]>64?this.state.age_range[1] + "+":this.state.age_range[1]} className={Styles.sliderRangeContainerValueInput}/>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.tab === "basic" &&
                                    <div>
                                        <div className={
                                            cx(Styles.subTitle,
                                                {
                                                    [Styles.subTitleTop]: Object.keys(this.state.channels).filter((item) => {
                                                        return this.state.budget[item].social && this.state.channels[item].selected
                                                    }).length < 1,
                                                })
                                        }>
                                            {this._renderText("item_31")}
                                            {
                                                false &&
                                                <img src={require("../../assets/images/info_icon.svg")}
                                                     className={Styles.subTitleIcon}/>
                                            }
                                        </div>
                                        <div className={Styles.checkMarksContainer}>
                                            <div className={Styles.checkMarksContainerItem}>
                                                <img src={require("../../assets/images/checkmark-disabled.svg")}
                                                     className={Styles.checkMarksContainerItemIcon}/>
                                                <div className={Styles.checkMarksContainerItemText}>
                                                    {marketRegister.adLanguage()}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.budget[item].search && this.state.channels[item].selected
                                            }).length > 0 &&
                                            <span>
                                            <div className={Styles.subTitle}>
                                                    {this._renderText("item_4")}
                                                <span
                                                    className={Styles.subTitleBold}>&nbsp;{this.state.industry.name}</span>,
                                                {this._renderText("item_5")}
                                                {
                                                    false &&
                                                    <img src={require("../../assets/images/info_icon.svg")}
                                                         className={Styles.subTitleIcon}/>
                                                }
                                            </div>
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.state.related_industries.sort(function (a, b) {
                                                        if (a.name < b.name) {
                                                            return -1;
                                                        }
                                                        if (a.name > b.name) {
                                                            return 1;
                                                        }
                                                        return 0;
                                                    }).map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !prop.selected &&
                                                                    <img onClick={() => this._selectIndustry(prop)}
                                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    prop.selected &&
                                                                    <img onClick={() => this._selectIndustry(prop)}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div onClick={() => this._selectIndustry(prop)}
                                                                     className={Styles.checkMarksContainerItemText}>
                                                                    {prop.name}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </span>
                                        }
                                        <div className={Styles.subTitle}>
                                            {this._renderText("item_6")} {
                                            false &&
                                            <img src={require("../../assets/images/info_icon.svg")}
                                                 className={Styles.subTitleIcon}/>
                                        }
                                        </div>
                                        {
                                            false &&
                                            <div className={Styles.checkMarksContainerItem}>
                                                {
                                                    !this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                }
                                                {
                                                    this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                }
                                                <div onClick={() => this._selectCountry()}
                                                     className={Styles.checkMarksContainerItemText}>
                                                    <div>{this._renderText("item_7")} {marketRegister.marketName()}</div>
                                                </div>
                                            </div>
                                        }
                                        <div className={Styles.inputContainer}>
                                            {
                                                this.state.regionLoader &&
                                                <div className={Styles.inputContainerLoader}>
                                                    <BeatLoader size={15} color={'#41CBC7'} loading={true}/>
                                                </div>
                                            }
                                            <input onFocus={() => this.setState({dropdown: true}, () => {
                                                if (this.state.country) {
                                                    this._selectCountry();
                                                }
                                            })}
                                                   onBlur={() => this.setState({dropdown: false})}
                                                   value={this.state.search}
                                                   onChange={(event) => this.setState({search: event.target.value})}
                                                   placeholder={this._renderText("item_8")}
                                                   className={
                                                       cx(Styles.input,
                                                           {
                                                               [Styles.inputDisabled]: this.state.country
                                                           })
                                                   }
                                            />
                                            {
                                                this.state.dropdown && this.state.regions.filter((item) => {
                                                    return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                }).filter((item) => {
                                                    return item.id !== this.state.country_region.id
                                                }).length > 0 &&
                                                <div className={Styles.inputDropdown}>
                                                    {
                                                        this._filterRegions(this.state.search).filter((item) => {
                                                            return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                        }).filter((item) => {
                                                            return item.id !== this.state.country_region.id
                                                        }).sort(function (a, b) {
                                                            if (a.name < b.name) {
                                                                return -1;
                                                            }
                                                            if (a.name > b.name) {
                                                                return 1;
                                                            }
                                                            return 0;
                                                        }).map((prop, key) => {
                                                            return (
                                                                <div key={key}
                                                                     onMouseDown={() => this._selectRegion(prop)}
                                                                     className={Styles.inputDropdownItem}>
                                                                    {prop.name}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            <div className={Styles.regionCheckMarksContainerItem}>
                                                {
                                                    !this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.regionCheckMarksContainerItemIcon}/>
                                                }
                                                {
                                                    this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                         className={Styles.regionCheckMarksContainerItemIcon}/>
                                                }
                                                <div onClick={() => this._selectCountry()}
                                                     className={Styles.regionCheckMarksContainerItemText}>
                                                    {this._renderText("item_7")} {marketRegister.marketName()}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Styles.regionsContainer}>
                                            {
                                                this.state.regions_selected &&
                                                this.state.regions_selected.filter((item) => {
                                                    return item.id !== this.state.country_region.id
                                                }).map((prop, i) => {
                                                    return (
                                                        <div key={i} className={Styles.regionsContainerItem}>
                                                            <div className={Styles.regionsContainerItemTitle}>
                                                                {prop.name}
                                                                {
                                                                    prop.parent &&
                                                                    <span
                                                                        className={Styles.regionsContainerItemSubtitle}>({prop.parent})</span>
                                                                }
                                                            </div>
                                                            <img onClick={() => this._removeRegion(prop)}
                                                                 src={require("../../assets/images/small_cross_white.png")}
                                                                 className={Styles.regionsContainerItemIcon}
                                                            />
                                                        </div>
                                                    )

                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                <div className={Styles.divider}/>
                                <div onClick={() => this._checkout()}
                                     className={
                                         cx(Styles.button,
                                             {
                                                 [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                 && this.state.targets.filter((item) => {
                                                     return item.selected
                                                 }).length > 0,
                                             })
                                     }>
                                    {this._renderText("item_14")}
                                    <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}&nbsp;{this.state.currency.toLowerCase()}
                                    </span>
                                    {
                                        this.state.regions_selected.length < 1 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_33")}</span>
                                    }
                                    {
                                        this.state.targets.filter((item) => {
                                            return item.selected
                                        }).length < 1
                                        && this.state.regions_selected.length > 0 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_42")}</span>
                                    }
                                    {
                                        Object.keys(this.state.channels).filter((item) => {
                                            return this.state.channels[item].selected && this.state.budget[item].low_traffic_flag && this.state.budget[item].search
                                        }).length > 0 && this.state.regions_selected.length > 0
                                        && this.state.targets.filter((item) => {
                                            return item.selected
                                        }).length > 0 &&
                                        <span className={Styles.buttonError}>{this._renderText("item_32")}</span>
                                    }
                                </div>
                                <div onClick={() => {
                                    this._back()
                                }} className={Styles.backButton}>
                                    {this._renderText("item_23")}
                                </div>
                            </div>
                            <div className={Styles.right}>

                                <div className={Styles.contentContainerRightInner}>
                                    <Basket
                                            updateBudget={this._updateBudget}
                                            selectDuration={this._selectDuration}
                                            props={this.props}
                                            nextView={"/signup/budget"}
                                            regions={["1"]}
                                            serviceFeeFixed={this.state.service_fee_fixed}
                                            serviceFeePercentage={this.state.service_fee_percentage}
                                            budget={this.state.budget}
                                            channels={this.state.channels}
                                            currency={this.state.currency}
                                            plan={this.state.plan}
                                            vat={this.state.vat}
                                            durations={this.state.durations}
                                            duration={this.state.duration}
                                    />
                                    <div onClick={() => this._checkout()} className={
                                        cx(Styles.contentContainerRightButton,
                                            {
                                                [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                && this.state.targets.filter((item) => {
                                                    return item.selected
                                                }).length > 0
                                            })
                                    }>
                                        {this._renderText("item_14")}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
    */
}

export default SignupFilter;


// WEBPACK FOOTER //
// ./src/pages/signup-filter/component.js